export const INITIAL_STATE_LOGIN_FORM = {
  codigo: "",
  pin: "",
};
